import { Route, Routes } from "react-router-dom";
import EmbedWidget from "../embed/EmbedWidget";

export const RoutesManager = ({}) => {
  return (
    <div className="pointer-events-auto h-full w-full overflow-auto">
      <Routes>
        <Route path="*" element={<EmbedWidget />} />
      </Routes>
    </div>
  );
};
